import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import BreadcrumbHeader from "../../../components/Header/BreadCrumHeader.jsx";
import CAMHeader from "../../../components/Header/CAMHeader";
import CAMDrawer from "../../../components/LeftSideBar/CAMDrawer";
import InvestigatorContainer from "../../../components/contsiners/InvestigatorContainer";
import ListCard from "../../../components/Card/ListCardDetails.jsx";
import DownloadAll from './DownlaodAllFilter.jsx'
import {
  Box,
  Grid,
  InputAdornment,
  OutlinedInput,
  CircularProgress,
  Button,
  TextField,
  Divider,
  IconButton,
  MenuItem,
  Select,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import DownloadIcon from "@mui/icons-material/Download";

import DropdownsBar from "../header/ProductSiteUnitSelector.jsx";
import TabsBar from "../header/TabsNav.jsx";
import BreadcrumbsBar from "../header/BreadcrumbNav.jsx";

import BatchesTable from "./batchesTable/BatchesTable.jsx";

import {
  downloadBatchesData,
  fetchBatches,
  resetDownloadBatchesData,
  getBatchDetails,
} from "../../../redux/batches/actions.js";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import Pagination from "../../../components/Pagination/index";

import "./batches.scss";
import BatchFilters from "./batchFilters.jsx/index.jsx";
import Label from "../../../components/Label/Label.jsx";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import DatePicker from "react-datepicker";
import ClearIcon from "@mui/icons-material/Clear";
import BatchDetailsTable from "./BatchDetailsTable.jsx";
import { set } from "date-fns";
import * as types from "../../../redux/batches/types.js";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { AddBox } from "@mui/icons-material";
import Loader from "../../../components/Loader/loader.jsx";

const DEBOUNCE_MS = 500;

const Batches = () => {
  const dispatch = useDispatch();

  const {
    product = { id: "", name: "" },
    site = { id: "", name: "" },
    unitOfOperation = { id: "", name: "" },
  } = useSelector((state) => state.shared.productSitesUopValues || {});

  const batchesSlice = useSelector((state) => state.batch?.batches || {});
  const batchDetails = useSelector((state) => state.batch?.batchDetails || {});
  const downloadedBatchesData = useSelector(
    (state) => state.batch?.downloadedBatchesData || {}
  );

  const { data: batchesData = {}, loader = false } = batchesSlice;

  const {
    results: resultsFromStore = [],
    total: totalCount = 0,
    page: currentPageFromStore = 1,
    page_size: pageSizeFromStore = 50,
    total_pages: totalPagesFromStore = 0,
  } = batchesData;

  const [page, setPage] = useState(currentPageFromStore || 1);
  const [rowsPerPage] = useState(pageSizeFromStore || 50);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [selectedBatchIds, setSelectedBatchIds] = useState([]);
  const [viewLogs, setViewLogs] = useState(false);
  const [batchTableData, setBatchTableData] = useState([]);
  const [batchID, setBatchId] = useState();
  const [downloadAll, setDownloadAll] = useState(false);

  // Debounce search (wait after user stops typing)
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search?.trim());
      // Reset to first page when the query meaningfully changes
      setPage(1);
    }, DEBOUNCE_MS);
    return () => clearTimeout(handler);
  }, [search]);

  // const formatDate = useCallback((date) => {
  //   if (!date) return null;
  //   const d = new Date(date);
  //   // Normalize to YYYY-MM-DD to match typical API expectations
  //   return d.toISOString().split("T")[0];
  // }, []);

  const formatDate = useCallback((date) => {
    if (!date) return null;
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }, []);

  const getDefaultDates = useCallback(() => {
    const now = "";
    const startDate = "";
    // startDate.setMonth(now.getMonth() - 3); // subtract 3 months
    return { startDate, endDate: now };
  }, []);

  const [batchState, setBatchState] = useState({
    ...getDefaultDates(),
    // metaDataStatus: "all",
    // batchStatus: "all",
  });

  // const [filterOpen, setFilterOpen] = useState(false);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "",
  });

  // Build payload from current local state.
  const buildPayload = useCallback(
    (pageArg = 1, searchArg = debouncedSearch, dates = batchState) => ({
      page: pageArg,
      page_size: rowsPerPage,
      unit_of_operation: unitOfOperation.id || undefined,
      // metadata_status: "approved",
      // batch_status: "Completed",
      from_date: formatDate(dates.startDate),
      to_date: formatDate(dates.endDate),
      search: searchArg || undefined,
    }),
    [rowsPerPage, unitOfOperation?.id, debouncedSearch, batchState, formatDate]
  );

  // Initial fetch (on mount only)
  useEffect(() => {
    dispatch({ type: types.CLEAR_ROW });
    if (unitOfOperation?.id) {
      dispatch(fetchBatches(buildPayload(1)));
    }
    setPage(1);
    setViewLogs(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Refetch when page or debouncedSearch changes.
  // IMPORTANT: We intentionally do NOT depend on `batchState` here,
  // so changing date range does not auto-fetch until user clicks "Search".
  useEffect(() => {
    const payload = buildPayload(page);
    if (unitOfOperation?.id) {
      dispatch(fetchBatches(payload));
    }
    setViewLogs(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, debouncedSearch, rowsPerPage, unitOfOperation?.id, dispatch]);

  // Reset selection when result set changes to avoid stale selections
  useEffect(() => {
    setSelectedBatchIds([]);
  }, [resultsFromStore]);

  // Handle download success
  useEffect(() => {
    if (downloadedBatchesData?.success && downloadedBatchesData?.data) {
      if (downloadedBatchesData?.success) {
        setSnackbar({
          open: true,
          message: "Success",
          severity: "success",
        });
        const a = document.createElement("a");
        const url = downloadedBatchesData.data.data.download_url;
        a.href = url;
        a.click();
        URL.revokeObjectURL(url);
      } else if (downloadedBatchesData?.message) {
        setSnackbar({
          open: true,
          message: downloadedBatchesData?.message,
          severity: "error",
        });
      }
    }
    setTimeout(() => {
      dispatch(resetDownloadBatchesData());
    }, 2000);
  }, [
    downloadedBatchesData?.success,
    downloadedBatchesData?.data,
    downloadedBatchesData?.file_name,
    dispatch,
  ]);

  // Handle download error
  useEffect(() => {
    if (downloadedBatchesData?.apiError) {
      setSnackbar({
        open: true,
        message: downloadedBatchesData?.message || "Download failed",
        severity: "error",
      });
      dispatch(resetDownloadBatchesData());
    }
  }, [
    downloadedBatchesData?.apiError,
    downloadedBatchesData?.message,
    dispatch,
  ]);

  const updateState = useCallback(
    (key, value) => setBatchState((prev) => ({ ...prev, [key]: value })),
    []
  );

  const handleSearch = useCallback(() => {
    setPage(1);
    const payload = buildPayload(1);
    dispatch(fetchBatches(payload));
    setViewLogs(false);
  }, [dispatch, buildPayload]);

  const handleResetFilters = useCallback(() => {
    const reset = {
      ...getDefaultDates(),
      // batchValueStatus: "all",
      // metaDataStatus: "all",
      // batchStatus: "all",
    };
    setBatchState(reset);
    setSearch("");
    setDebouncedSearch("");
    setPage(1);
    dispatch(
      fetchBatches({
        ...buildPayload(1, ""),
        from_date: formatDate(reset.startDate),
        to_date: formatDate(reset.endDate),
        // metadata_status: "all",
        // batch_status: "all",
        // batch_value_status: undefined,
      })
    );
    setViewLogs(false);
  }, [dispatch, buildPayload, getDefaultDates, formatDate]);

  const handleSearchChange = useCallback((e) => {
    setSearch(e.target.value);
  }, []);

  const onClickDownload = useCallback(() => {
    if (!unitOfOperation?.id) {
      return setSnackbar({
        open: true,
        message: "Please select a unit operation first.",
        severity: "warning",
      });
    }
    if (!selectedBatchIds?.length > 0) {
      setSnackbar({
        open: true,
        message: "Please select at least one batch to download.",
        severity: "warning",
      });
      return;
    }
    if (downloadedBatchesData?.loader) return; // guard against double-clicks
    dispatch(
      downloadBatchesData({
        batch_ids: selectedBatchIds,
        unit_op_id: unitOfOperation?.id,
      })
    );
  }, [dispatch, selectedBatchIds, downloadedBatchesData?.loader]);

  const totalPages = useMemo(
    () =>
      totalPagesFromStore || Math.max(1, Math.ceil(totalCount / rowsPerPage)),
    [totalPagesFromStore, totalCount, rowsPerPage]
  );

  // Enter to trigger search
  const searchInputRef = useRef(null);
  const onSearchKeyDown = useCallback(
    (e) => {
      if (e.key === "Enter") {
        handleSearch();
      }
    },
    [handleSearch]
  );

  // Stable prop object for table to reduce re-renders
  const stableBatchesState = useMemo(
    () => ({
      ...batchesSlice,
      data: { ...batchesData, results: resultsFromStore },
    }),
    [batchesSlice, batchesData, resultsFromStore]
  );

  const viewAuditLogs = () => {
    setViewLogs(!viewLogs);
  };

  const handleViewDetails = (type, data) => {
    setBatchId(data?.batch_id);
    setViewLogs(!viewLogs);
    setBatchTableData();
    dispatch(
      getBatchDetails({
        batch_id: data?.batch_id,
        unit_op_id: unitOfOperation.id,
      })
    );
  };

  useEffect(() => {
    if (batchDetails?.data && batchDetails?.data?.length > 0) {
      setBatchTableData(batchDetails?.data[0] || []);
    }
  }, [batchDetails?.data]);

  const handleDownloadAll = () => {

    setDownloadAll(true)
  }
  return (
    <div>
      <CAMHeader />
      <CAMDrawer />

      <InvestigatorContainer>
        <TabsBar />
        <DropdownsBar />

        {/* <Grid container alignItems="center" spacing={2}>
          <Grid item xs={12} md={6}>
          </Grid>
        </Grid> */}

        <Divider sx={{ mx: 2 }} />
        <Box sx={{ py: 0.5 }}>
          <BreadcrumbsBar />
        </Box>
        <Divider sx={{ mx: 2 }} />

        <Box >
            {/* {filterOpen && (
              <Grid item xs={2.5} className="batch-filter-panel">
                <Box className="filter-card-wrapper">
                  <Box className="filter-scrollable-panel">
                    <BatchFilters
                      batchState={batchState}
                      updateState={updateState}
                      handleClearAll={handleResetFilters}
                      handleApply={handleSearch}
                      setFilterOpen={setFilterOpen}
                    />
                  </Box>
                </Box>
              </Grid>
            )} */}

            <Box >
              {/* Toolbar */}

              {/* Table Section */}
              {viewLogs && (
                <>
                  <Box
                    mt={1}
                    mb={2}
                    gap={2}
                    display={"flex"}
                    flexDirection={"column"}
                  >
                    <BreadcrumbHeader
                      text={""}
                      onBackClick={() => setViewLogs(false)}
                    />
                  </Box>
                </>
              )}
              <Box >
                <Box  >
                  {viewLogs ? (
                    <>
                      <Box
                        display={"flex"}
                        gap={2}
                        flexDirection={"row"}
                        height={'calc(100vh - 250px)'}

                      >
                        <ListCard
                          openData={batchTableData}
                          batchID={batchID}
                          data={batchDetails}
                          handleMenuClick={(e) => setBatchTableData(e)}
                        />
                        <BatchDetailsTable
                          data={batchTableData}
                          batchDetails={batchDetails}
                        />
                      </Box>
                    </>
                  ) : (
                    <>
                      <Box
                        className="batches-toolbar"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        {/* Search */}
                        <OutlinedInput
                          inputRef={searchInputRef}
                          size="small"
                          showYearDropdown
                          placeholder="Search Batch ID"
                          value={search}
                          onChange={handleSearchChange}
                          onKeyDown={onSearchKeyDown}
                          sx={{
                            width: 240,
                            backgroundColor: "#fff",
                            borderRadius: "6px",
                          }}
                          startAdornment={
                            <InputAdornment position="start">
                              <SearchIcon fontSize="small" />
                            </InputAdornment>
                          }
                        />

                        {/* Divider with some spacing */}
                        <Divider
                          orientation="vertical"
                          flexItem
                          sx={{ my: 1 }}
                        />

                        {/* Date Range */}
                        <Box
                          sx={{
                            display: "flex",
                            gap: 1,
                            p: 0.5,
                            borderRadius: "8px",
                            background: "#e9e9e9ff",
                          }}
                          className="date-range-picker-report"
                        >
                          {[
                            ["startDate", "From"],
                            ["endDate", "To"],
                          ].map(([key, placeholder]) => (
                            <DatePicker
                              key={key}
                              showYearDropdown
                              scrollableYearDropdown
                              yearDropdownItemNumber={50}
                              // popperClassName="custom-datepicker-popper"
                              selected={batchState[key]}
                              onChange={(date) => updateState(key, date)}
                              selectsStart={key === "startDate"}
                              selectsEnd={key === "endDate"}
                              startDate={batchState.startDate}
                              endDate={batchState.endDate}
                              minDate={
                                key === "endDate"
                                  ? batchState.startDate ||
                                  new Date("1900-01-01")
                                  : new Date("1900-01-01")
                              }
                              maxDate={new Date()} // keep upper bound at today
                              placeholderText={placeholder}
                              dateFormat="dd-MMM-yyyy"
                              fixedHeight
                              renderCustomHeader={({
                                date,
                                decreaseMonth,
                                increaseMonth,
                                changeYear,
                                prevMonthButtonDisabled,
                                nextMonthButtonDisabled,
                              }) => (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    px: 1.5,
                                    py: 1,
                                    bgcolor: "primary.main",
                                    color: "common.white",
                                    borderRadius: "8px 8px 0 0",
                                  }}
                                >
                                  <IconButton
                                    onClick={decreaseMonth}
                                    disabled={prevMonthButtonDisabled}
                                    sx={{ color: "common.white", p: 0.5 }}
                                    size="small"
                                  >
                                    <ArrowBackIosIcon fontSize="small" />
                                  </IconButton>

                                  <Box
                                    sx={{
                                      mx: 1,
                                      fontWeight: 500,
                                      cursor: "default",
                                      width: 80,
                                      textAlign: "center",
                                    }}
                                  >
                                    <Label
                                      text={date.toLocaleString("default", {
                                        month: "long",
                                      })}
                                      color="#ffff"
                                      fontSize={16}
                                      fontWeight={600}
                                    />
                                  </Box>

                                  <Select
                                    value={date.getFullYear()}
                                    onChange={(e) =>
                                      changeYear(Number(e.target.value))
                                    }
                                    size="small"
                                    onMouseDown={(e) => e.stopPropagation()} // prevent closing
                                    onClick={(e) => e.stopPropagation()} // prevent closing
                                    sx={{
                                      fontSize: 13,
                                      color: "text.primary",
                                      bgcolor: "background.paper",
                                      borderRadius: 1,
                                      // "& .MuiSelect-select": {
                                      //   py: 0.25,
                                      //   px: 1,
                                      // },
                                    }}
                                  >
                                    {Array.from(
                                      { length: 50 },
                                      (_, i) => new Date().getFullYear() - i
                                    ).map((y) => (
                                      <MenuItem key={y} value={y}>
                                        {y}
                                      </MenuItem>
                                    ))}
                                  </Select>

                                  <IconButton
                                    onClick={increaseMonth}
                                    disabled={nextMonthButtonDisabled}
                                    sx={{ color: "common.white", p: 0.5 }}
                                    size="small"
                                  >
                                    <ArrowForwardIosIcon fontSize="small" />
                                  </IconButton>
                                </Box>
                              )}
                              customInput={
                                <TextField
                                  size="small"
                                  sx={{
                                    width: 160,
                                    backgroundColor: "#fff",
                                    borderRadius: "6px",
                                  }}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <CalendarTodayIcon fontSize="small" />
                                      </InputAdornment>
                                    ),
                                    readOnly: true,
                                  }}
                                />
                              }
                            />
                          ))}

                          <Button
                            onClick={handleSearch}
                            variant="contained"
                            sx={{
                              textTransform: "none",
                              backgroundColor: "#3882DB",
                              "&:hover": { backgroundColor: "#1565c0" },
                              minHeight: "36px",
                            }}
                          >
                            <Label text="Search" color="#fff" />
                          </Button>
                        </Box>

                        <Button
                          onClick={handleResetFilters}
                          variant="outlined"
                          sx={{ textTransform: "none", minHeight: "36px" }}
                          startIcon={<ClearIcon />}
                        >
                          <Label text="Reset" />
                        </Button>

                        {/* <Divider orientation="vertical" flexItem sx={{ my: 1 }} /> */}

                        {/* <Button
                  variant={!viewLogs ? "outlined" : "contained"}
                  sx={{
                    // backgroundColor: "#154D8F",
                    textTransform: "none",
                    // "&:hover": { backgroundColor: "#1565c0" },
                  }}
                  onClick={viewAuditLogs}
                >
                  <Label text="Audit Trail" />
                </Button> */}
                        {/* Action Buttons */}
                        <Box sx={{ ml: 1 }}>
                          <Button
                            variant="contained"
                            startIcon={
                              downloadedBatchesData?.loader ? (
                                <CircularProgress
                                  size={16}
                                  sx={{ color: "#fff" }}
                                />
                              ) : (
                                <DownloadIcon />
                              )
                            }
                            onClick={onClickDownload}
                            disabled={!!downloadedBatchesData?.loader }
                            // disabled
                            sx={{ textTransform: "none", minHeight: "36px" }}
                          >
                            <Label
                              text={
                                downloadedBatchesData?.loader
                                  ? "Downloading"
                                  : "Download"
                              }
                              color="#fff"
                            />
                          </Button>
                        </Box>
                        <Box sx={{ ml: 1 }}>
                          <Button
                            variant="contained"
                            startIcon={

                              <DownloadIcon />

                            }
                            onClick={handleDownloadAll}
                            sx={{ textTransform: "none", minHeight: "36px" , marginRight: 2}}
                          >
                            <Label
                              text={
                                'Download all'
                              }
                              color="#fff"
                            />
                          </Button>
                        </Box>
                      </Box>
                      <Box sx={{height:'calc(100vh - 245px)' , display:'flex', flexDirection:'column', justifyContent:'space-between'}}>
                      <BatchesTable
                        batchesState={stableBatchesState}
                        loadingOverride={loader}
                        selectedBatchIds={selectedBatchIds}
                        onSelectionChange={setSelectedBatchIds}
                        handleViewDetails={handleViewDetails}
                      />
                      {loader && <Loader />}
                      {!viewLogs && (
                        <Box sx={{ mt: 1 }}>
                          {
                            <Pagination
                              count={totalPages}
                              page={page}
                              onChange={(_e, val) => setPage(val)}
                            />
                          }
                        </Box>
                      )}
                      </Box>
                      <DownloadAll open={downloadAll} onClose={() => setDownloadAll(false)} />
                    </>
                  )}
                </Box>

                {/* Sticky Footer */}

              </Box>
            </Box>
          
        </Box>
      </InvestigatorContainer>

      {snackbar.open && (
        <CustomizedSnackbars
          severity={snackbar.severity}
          state={snackbar.open}
          text={snackbar.message}
          handleClose={() =>
            setSnackbar({ open: false, message: "", severity: "" })
          }
        />
      )}
    </div>
  );
};

export default Batches;
